
import {
  computed, defineComponent, reactive,
} from 'vue';
import Card from '@/core/components/UI/Card.vue';
import CampoNumerico from '@/core/components/UI/CampoNumerico.vue';
import SelecionarData from '@/core/components/UI/SelecionarData.vue';
import InspecaoValoresArquivos from '@/components/InspecaoValoresArquivos.vue';
import { IInspecaoValores } from '@/models/Entidades/IInspecaoValores';

export default defineComponent({
  name: 'InspecaoValores',
  props: {
    inspecaoValores: {
      type: Object as () =>IInspecaoValores,
      required: true,
    },
    bloquearCampos: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    Card,
    CampoNumerico,
    SelecionarData,
    InspecaoValoresArquivos,
  },
  emits: ['update:inspecaoValores', 'change'],
  setup(props, { emit }) {
    const state = reactive({
      enviandoArquivos: false,
      excluindoArquivos: false,
    });

    const computedInspecaoValores = computed({
      get: () => props.inspecaoValores,
      set: (valor: IInspecaoValores) => {
        emit('update:inspecaoValores', valor);
      },
    });

    function selecionarSeguroNovo() {
      computedInspecaoValores.value.seguroNovo = true;
      computedInspecaoValores.value.seguroRenovacao = false;
    }

    function selecionarSeguroRenovacao() {
      computedInspecaoValores.value.seguroNovo = false;
      computedInspecaoValores.value.seguroRenovacao = true;
    }

    function selecionarSinistralidadeSim() {
      computedInspecaoValores.value.sinistralidadeUltimosAnosSim = true;
      computedInspecaoValores.value.sinistralidadeUltimosAnosNao = false;
    }

    function selecionarSinistralidadeNao() {
      computedInspecaoValores.value.sinistralidadeUltimosAnosSim = false;
      computedInspecaoValores.value.sinistralidadeUltimosAnosNao = true;
    }

    function change() {
      emit('change');
    }

    return {
      props,
      computedInspecaoValores,
      state,
      selecionarSeguroNovo,
      selecionarSeguroRenovacao,
      selecionarSinistralidadeSim,
      selecionarSinistralidadeNao,
      change,
    };
  },
});
